import { useLingui, Trans } from '@lingui/react/macro'
import { useEffect } from 'react'
import useNav from '../../hooks/useNav'
import { useBoundStore } from '../../zustand'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table'

const Stock = () => {
    const { t } = useLingui()
    const { nav, setNav } = useNav()
    const spareparts = useBoundStore((state) => state.spareparts);

    useEffect(() => {
        setNav({ ...nav, title: t`Stock` })
    }, [])

    return (
        <div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead><Trans>Naam</Trans></TableHead>
                        <TableHead><Trans>Beschrijving</Trans></TableHead>
                        <TableHead><Trans>Aantal</Trans></TableHead>
                        <TableHead><Trans>SKU</Trans></TableHead>
                        <TableHead><Trans>Merk</Trans></TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array.isArray(spareparts) ? (
                        spareparts.map((sparepart, i) => (
                            <TableRow key={`${sparepart?.m_sSKU}-${i}`}>
                                <TableCell>{sparepart?.m_sPARTNAAM}</TableCell>
                                <TableCell>{sparepart?.m_sOMSCHRIJVING}</TableCell>
                                <TableCell>{sparepart?.m_rAANTAL}</TableCell>
                                <TableCell>{sparepart?.m_sSKU}</TableCell>
                                <TableCell>{sparepart?.m_sMERK}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5}><Trans>Loading or invalid spare parts</Trans></TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>
    )
}

export default Stock